const _local = 'local',
  _session = 'session';

// 本地存储操作
const _setStorage = (type, key, val) => {
  if (typeof val === 'object') {
    val = JSON.stringify(val);
  }
  window[`${type}Storage`].setItem(key, val);
};

// 存储获取
const _getStorage = (type, key) => {
  let str = window[`${type}Storage`].getItem(key) || '',
    data = '';
  try {
    data = JSON.parse(str);
  } catch (error) {
    data = str;
  }
  return data;
};

// 删除本地存储
const _remove = (type, key) => {
  window[`${type}Storage`].removeItem(key);
};

// 获取session本地存储
export const setSession = (key, val) => {
  return _setStorage(_session, key, val);
};

// 获取session本地存储
export const setLocal = (key, val) => {
  return _setStorage(_local, key, val);
};

// 获取session本地存储
export const getSession = key => {
  return _getStorage(_session, key);
};

// 获取session本地存储
export const getLocal = key => {
  return _getStorage(_local, key);
};

// 删除session本地存储
export const removeSession = key => {
  return _remove(_session, key);
};

// 删除local本地存储
export const removeLocal = key => {
  return _remove(_local, key);
};

// 获取用户信息
export const setUser = userInfo => {
  console.log(userInfo);
  return setLocal('userInfo', userInfo);
};

// 获取用户信息
export const getUser = () => {
  let localUser = getLocal('userInfo');
  if (Object.keys(localUser).length > 0) {
    removeLocal('userInfo');
    setUser(localUser);
  }
  return localUser;
};

// 删除用户信息
export const removeUser = () => {
  removeSession('userInfo');
};

// 获取用户实名信息
export const setReal = realInfo => {
  return setSession('realInfo', realInfo);
};

// 获取用户实名信息
export const getReal = () => {
  let localReal = getSession('realInfo');
  if (Object.keys(localReal).length > 0) {
    removeSession('realInfo');
    setReal(localReal);
  }
  return localReal;
};



// WEBPACK FOOTER //
// ./src/utils/storage.js